export default "__VITE_IMAGE_ASSET__3456c453__";